import * as county from '../masterdata/county/county.const';
import { STATE_MA } from '../masterdata/states/state.const';

export const MOPC = {
    _id: '507f1f77bcf86cd799439011',
    name: 'Massachusetts Office of Public Collaboration',
    acronym: 'MOPC',
    deletable: false,
    activatable: false,
    editable: false,
    active: true,
    contact: {
        addressLine1: '100 William T. Morrissey Boulevard',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02125',
        officePhone: '(617) 287-4040',
        county: county.COUNTY_SUFFOLK,
    },
};

export const CCDRC = {
    _id: '507f1f77bcf86cd799439013',
    name: 'Cape Cod Dispute Resolution Center',
    acronym: 'CCDRC',
    active: true,
    contact: {
        addressLine1: '22 Old Tote Road',
        city: 'Orleans',
        state: STATE_MA,
        zipCode: '02653',
        officePhone: '(508) 240-1717',
        county: county.COUNTY_BARNSTABLE,
    },
};

export const CDSC = {
    _id: '507f1f77bcf86cd799439015',
    name: 'Community Dispute Settlement Center',
    acronym: 'CDSC',
    active: true,
    contact: {
        addressLine1: '60 Gore Street',
        city: 'Cambridge',
        state: STATE_MA,
        zipCode: '02141',
        officePhone: '(617) 876-5376',
        county: county.COUNTY_MIDDLESEX,
    },
};

export const CRG = {
    _id: '507f1f77bcf86cd799439014',
    name: 'Collaborative Resolutions Group',
    acronym: 'CRG',
    active: true,
    contact: {
        addressLine1: 'PO Box 931',
        city: 'Greenfield',
        state: STATE_MA,
        zipCode: '01301',
        officePhone: '(413) 774-7469',
        county: county.COUNTY_FRANKLIN,
    },
};

export const FSCM = {
    _id: '507f1f77bcf86cd799439016',
    name: 'Family Services of Central Massachusetts',
    acronym: 'FSCM',
    active: true,
    contact: {
        addressLine1: '210 Lincoln Street',
        city: 'Worcester',
        state: STATE_MA,
        zipCode: '01605',
        officePhone: '(508)-796-1971',
        county: county.COUNTY_WORCESTER,
    },
};

export const GBCDR = {
    _id: '507f1f77bcf86cd799439017',
    name: 'Greater Brockton Center for Dispute Resolution',
    acronym: 'GBCDR',
    active: true,
    contact: {
        addressLine1: '215 Main Street',
        addressLine2: 'Room 207',
        city: 'Brockton',
        state: STATE_MA,
        zipCode: '02301',
        officePhone: '(508) 897-2868',
        county: county.COUNTY_PLYMOUTH,
    },
};

export const MCC = {
    _id: '507f1f77bcf86cd799439020',
    name: 'Middlesex Community College Law Center',
    acronym: 'MCC',
    active: true,
    contact: {
        addressLine1: '88 Middle Street',
        city: 'Lowell',
        state: STATE_MA,
        zipCode: '01852',
        officePhone: '(978) 656-3340',
        county: county.COUNTY_MIDDLESEX,
    },
};

export const MMS = {
    _id: '507f1f77bcf86cd799439022',
    name: 'Metropolitan Mediation Services',
    acronym: 'MMS',
    active: true,
    contact: {
        addressLine1: '40 Webster Place',
        city: 'Brookline',
        state: STATE_MA,
        zipCode: '02445',
        officePhone: '(617) 241-0300',
        county: county.COUNTY_NORFORK,
    },
};

export const MSI = {
    _id: '507f1f77bcf86cd799439019',
    name: 'Mediation Services of North Central Massachusetts',
    acronym: 'MSI',
    active: true,
    contact: {
        addressLine1: '435 Lancaster Street',
        addressLine2: 'Suite 224',
        city: 'Leominster',
        state: STATE_MA,
        zipCode: '01453',
        officePhone: '(978) 466-9595',
        county: county.COUNTY_WORCESTER,
    },
};

export const MVMP = {
    _id: '507f1f77bcf86cd799439018',
    name: `Martha's Vineyard Mediation Program`,
    acronym: 'MVMP',
    active: true,
    contact: {
        addressLine1: 'PO Box 761',
        city: 'Vineyard Haven',
        state: STATE_MA,
        zipCode: '02568',
        officePhone: '(508) 693-2999',
        county: county.COUNTY_DUKES,
    },
};

export const MWMS = {
    _id: '507f1f77bcf86cd799439023',
    name: 'Metrowest Mediation Services',
    acronym: 'MWMS',
    active: true,
    contact: {
        addressLine1: '220 North Main Street',
        addressLine2: 'Unit 106',
        city: 'Natick',
        state: STATE_MA,
        zipCode: '01760',
        officePhone: '(508) 872-9495',
        county: county.COUNTY_MIDDLESEX,
    },
};

export const TRC = {
    _id: '507f1f77bcf86cd799439021',
    name: 'The Resolution Center',
    acronym: 'TRC',
    active: true,
    contact: {
        addressLine1: '100 Cummings Center',
        addressLine2: 'Suite 307J',
        city: 'Beverly',
        state: STATE_MA,
        zipCode: '01951',
        officePhone: '(978) 232-1212',
        county: county.COUNTY_ESSEX,
    },
};

export const U413 = {
    _id: '507f1f77bcf86cd799439012',
    name: 'Upside 413',
    acronym: 'U413',
    active: true,
    contact: {
        addressLine1: '1 Fenn Street',
        addressLine2: '4th Floor',
        city: 'Pittsfield',
        state: STATE_MA,
        zipCode: '01201',
        officePhone: '(413) 443-7138',
        officePhoneExt: '212',
        county: county.COUNTY_BERKSHIRE,
    },
};

export const EVENSEL = {
    _id: '507f1f77bcf86cd799439010',
    name: 'Evensel',
    acronym: 'EVENSEL',
    active: true,    
};

export const CENTERS = [MOPC, CCDRC, CRG, CDSC, FSCM, GBCDR, MVMP, MSI, MMS, MWMS, MCC, TRC, U413, EVENSEL];

export const CENTERS_DHCD = [MOPC, CRG, CDSC, FSCM, GBCDR, MVMP, MSI, MMS, MWMS, MCC, TRC, U413, EVENSEL].map(d => d._id);
export const CENTERS_PMP = [MOPC, CRG, CDSC, MVMP, MWMS, TRC, EVENSEL].map(c => c._id);
export const CENTERS_MBF = [MOPC, CCDRC, CRG, CDSC, MWMS, TRC, U413, EVENSEL].map(c => c._id);
